import { Link, useLocation } from 'react-router-dom';
import { useForm } from '@tanstack/react-form';

import { cn } from '@/lib/utils';

import type { FormFooterProps, FormProps } from '@/types/form/form-props';
import { fieldToInputProps, toFormProps } from '@/utils/shared/form';
import { Button } from '@/shared/components/ui/button';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';

import { VerifyOtpInput, VerifyOtpInputSchema } from '../api/verify-otp';
import OtpInput from './otp-input';

export function VerifyOtpForm({
  defaultValues,
  onSubmit,
  Footer = VerifyOtpFormFooter,
  className,
}: FormProps<VerifyOtpInput>) {
  const form = useForm({
    defaultValues,
    validators: { onSubmit: VerifyOtpInputSchema },
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <form {...toFormProps(form)} className={cn('space-y-6', className)}>
      <form.Field name="code">{(field) => <OtpInput {...fieldToInputProps(field, '')} />}</form.Field>

      <form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
        {([canSubmit, isSubmitting]) => <Footer canSubmit={canSubmit} isSubmitting={isSubmitting} />}
      </form.Subscribe>
    </form>
  );
}

export function VerifyOtpFormFooter({
  canSubmit,
  isSubmitting,
  resetText = 'Avbryt',
  submitText = 'Logga in',
}: FormFooterProps) {
  const { search } = useLocation();

  return (
    <div className="flex gap-2 float-right">
      <Button variant="outline" type="reset" asChild>
        <Link to={`/auth/login${search}`}>{resetText}</Link>
      </Button>
      <LoadingButton disabled={!canSubmit} isLoading={isSubmitting} type="submit">
        {submitText}
      </LoadingButton>
    </div>
  );
}
